module.exports = __webpack_public_path__ + "img/left.746b2be4.png";